export default __webpack_public_path__ + "static/media/gif3.e4475a79.gif";